// PRESENTATION REQUEST FORM - HARDCODE
//IMPORTS:
//EXTERNAL & PACKAGE
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../../../components/heading'
import Navbar from '../../../components/navbar'
import Footer from '../../../components/footer'
import '../../../styles/form.css'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************     
const presentationRequestPage = ({data}) => {
    
    const presentationRequest = data.presentation_request.edges
   
    return (
        
        <div>
                    
            
            
            <Helmet>
                   <title>NJCCIC Presentations</title>
                    <meta name="description" content="The NJCCIC provides a variety of free presentation on cyber security topics"/>
            </Helmet>
        
            <Heading/>
            
            <Navbar/>        
        
            <div class="container containerWidth" id="formDiv">
                <form action="https://www.state.nj.us/cgi-bin/formmail.pl" method="post" name="computer" onsubmit="window.alert('Thank you for submitting')" id="computer">
                    <input name="recipient" type="hidden" value="CyberTraining@cyber.nj.gov"/>
                    <input name="subject" type="hidden" value="presentation-request-form"/>
                    <input name="print_blank_fields" type="hidden" value="1"/>
                    <input name="title" type="hidden" value="NJCCIC Presentation Request Form"/>
                    <input type="hidden" name="redirect" value="https://www.cyber.nj.gov/redirect"/>

                    <h1 class="pageHeader centerText" id="formHeader">Presentation Request</h1>
                    <div class="form-row" id="formIntro">
                        <div class="form-group col-sm" id="formRow">
                            <h2 class="headerPadding" id="formH2">Our staff are available to provide remote presentations using various video-teleconferencing platforms based on your agency or organization needs at no cost. We will be conducting virtual-only presentations until further notice, and scheduling is based on availability. We will update our website with any changes. Please try to submit presentation requests at least 30 days prior to your scheduled event. Below is a complete list of available presentation topics.</h2>
                        </div>
                    </div>
                    <div class="presentationFormBlock">
                        <h3 class="formHeaderPadding spacers formSubheader">CONTACT INFORMATION</h3>
                        <div class="formSection">

                            <div class="form-row">
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">FIRST NAME*</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="FIRST NAME" type="text" required/>
                                </div>
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">LAST NAME*</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="LAST NAME" type="text" required/>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">ORGANIZATION*</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="ORGANIZATION" type="text" required />
                                </div>
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">EMAIL ADDRESS*</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="email" type="email"  required/>
                                    
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">PHONE NUMBER*</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="PHONE NUMBER" type="text" required />
                                </div>
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">EXTENSION</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="EXTENSION" type="number" />
                                </div> 
                            </div>
                            <div class="form-row">
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">EVENT DATE*</label>
                                    <input class="form-control form-control-lg noBorderCurve eventCalendar" name="EVENT DATE" type="date" required/>
                                </div>
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">EVENT TIME*</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="EVENT TIME" type="time" required/>
                                </div> 
                            </div>
                        </div>
                        <h3 class="formHeaderPadding spacers formSubheader">EVENT INFORMATION</h3>
                        <div class="formSection">
                            <div class="form-row">
                                <div class="form-group col-12">
                                    <label class="form-check-label" for="" id="reportTypeLabel">SELECT A PRESENTATION*</label> 
                                    <div class="form-control form-control-lg noBorderCurve">
                                        <select class="presentationSelect" name="PRESENTATION SELECTED"  required>
                                            <option>Current State of Cybercrime</option>
                                            <option>Ransomware Prevention</option>
											<option>Cybersecurity Best Practices & Careers (for high school audiences)</option>
                                            <option>Custom Presentation</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">WILL THE PRESENTATION BE ONLINE OR IN PERSON?*</label>
                                    <div class="form-control form-control-lg noBorderCurve">
                                        <select class="presentationSelect" name="PRESENTATION SELECTED"  required>
                                            <option>In Person</option>
                                            <option>Online</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">PRESENTATION START TIME*</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="PRESENTATION START TIME" type="time" required/>
                                </div> 
                            </div>
                            <div class="form-row">
                                <div class="form-group col-12">
                                    <label class="form-check-label" for="" id="reportTypeLabel">IF REQUESTING A CUSTOMIZED PRESENTATION, PLEASE PROVIDE PRESENTATION DETAILS</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="CUSTOM PRESENTATION REQUEST DETAILS" type="text"/>
                                </div> 
                            </div>                  
                            <div class="form-row">
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">LENGTH OF PRESENTATION*</label>        
                                    <div class="form-control form-control-lg noBorderCurve">
                                        <select class="presentationSelect" name="LENGTH OF PRESENTATION" required >
                                            <option>30 minutes</option>
                                            <option>60 minutes</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">TARGET AUDIENCE*</label>        
                                    <div class="form-control form-control-lg noBorderCurve">
                                        <select class="presentationSelect" name="TARGET AUDIENCE" required>
                                            <option >General Users</option>
                                            <option>IT Professionals</option>
                                            <option>Management</option>
                                            <option>Other</option>
                                        </select>
                                    </div>
                                </div>
                            </div>    
                            <div class="form-row">
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">IF "OTHER," PLEASE SPECIFY TARGET AUDIENCE</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="OTHER TARGET AUDIENCE" type="text"/>
                                </div>
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">APPROXIMATE AUDIENCE SIZE*</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="APPROXIMATE AUDIENCE SIZE" type="number" required/>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-12">
                                    <label class="form-check-label" for="" id="reportTypeLabel">VENUE NAME*</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="VENUE NAME" type="text" required/>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">ADDRESS*</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="ADDRESS" type="text" required/>
                                </div>
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">CITY*</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="CITY" type="text" required/>
                                </div>
                            </div>
                             <div class="form-row">
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">STATE*</label>
                                    <div class="form-control form-control-lg noBorderCurve">
                                        <select class="presentationSelect" name="STATE" required >
                                            <option value="AL">Alabama</option>
                                            <option value="AK">Alaska</option>
                                            <option value="AZ">Arizona</option>
                                            <option value="AR">Arkansas</option>
                                            <option value="CA">California</option>
                                            <option value="CO">Colorado</option>
                                            <option value="CT">Connecticut</option>
                                            <option value="DE">Delaware</option>
                                            <option value="DC">District Of Columbia</option>
                                            <option value="FL">Florida</option>
                                            <option value="GA">Georgia</option>
                                            <option value="HI">Hawaii</option>
                                            <option value="ID">Idaho</option>
                                            <option value="IL">Illinois</option>
                                            <option value="IN">Indiana</option>
                                            <option value="IA">Iowa</option>
                                            <option value="KS">Kansas</option>
                                            <option value="KY">Kentucky</option>
                                            <option value="LA">Louisiana</option>
                                            <option value="ME">Maine</option>
                                            <option value="MD">Maryland</option>
                                            <option value="MA">Massachusetts</option>
                                            <option value="MI">Michigan</option>
                                            <option value="MN">Minnesota</option>
                                            <option value="MS">Mississippi</option>
                                            <option value="MO">Missouri</option>
                                            <option value="MT">Montana</option>
                                            <option value="NE">Nebraska</option>
                                            <option value="NV">Nevada</option>
                                            <option value="NH">New Hampshire</option>
                                            <option value="NJ">New Jersey</option>
                                            <option value="NM">New Mexico</option>
                                            <option value="NY">New York</option>
                                            <option value="NC">North Carolina</option>
                                            <option value="ND">North Dakota</option>
                                            <option value="OH">Ohio</option>
                                            <option value="OK">Oklahoma</option>
                                            <option value="OR">Oregon</option>
                                            <option value="PA">Pennsylvania</option>
                                            <option value="RI">Rhode Island</option>
                                            <option value="SC">South Carolina</option>
                                            <option value="SD">South Dakota</option>
                                            <option value="TN">Tennessee</option>
                                            <option value="TX">Texas</option>
                                            <option value="UT">Utah</option>
                                            <option value="VT">Vermont</option>
                                            <option value="VA">Virginia</option>
                                            <option value="WA">Washington</option>
                                            <option value="WV">West Virginia</option>
                                            <option value="WI">Wisconsin</option>
                                            <option value="WY">Wyoming</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group col-12 col-md">
                                    <label class="form-check-label" for="" id="reportTypeLabel">ZIP/POSTAL CODE*</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="ZIP/POSTAL CODE" type="number" required/>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-12">
                                    <label class="form-check-label" for="" id="reportTypeLabel">ADDITIONAL COMMENTS</label>
                                    <input class="form-control form-control-lg noBorderCurve" name="ADDITIONAL DETAILS" type="text"/>
                                </div>
                            </div>
                        
                        </div>
                         
                        <div class="spacers" id="lastBlock">
                            <button class="btn btn-primary spacers presentationRequestButton" type="submit">SUBMIT</button>
                        </div>

                    </div>

                </form>

            </div>

            <Footer/>                 
            
        </div>

    )
    
}
//*******************************************************************
//*******************************************************************
export const query = graphql`
    query {
        presentation_request: allButterPage(filter: {slug: { eq: "presentation-request" } }) {
            edges {
                node {
                    slug
                    seo_title
                    page_title 
                }
            }
        }
    }
`
export default presentationRequestPage
